import { render, staticRenderFns } from "./regionalStandardsSystem.vue?vue&type=template&id=99e4ba50&scoped=true&"
import script from "./regionalStandardsSystem.vue?vue&type=script&lang=ts&"
export * from "./regionalStandardsSystem.vue?vue&type=script&lang=ts&"
import style0 from "./regionalStandardsSystem.vue?vue&type=style&index=0&id=99e4ba50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e4ba50",
  null
  
)

export default component.exports